var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_12",
    "data-name": "Component 13 \\u2013 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#7bb6c6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(12 5.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M416.641,192.4c.129-3.209.262-3.513.385-6.722.027-.711-.064-.758-.959-1.064a3.434,3.434,0,0,1-1.766-1.494,3.842,3.842,0,0,1-.631-3.41c.255-.825.536-4.787.872-5.6a1.025,1.025,0,0,1,1.071-.708c.636.067.648.541.665.921.021.486,0,6.21-.006,6.7,0,.122-.054.267.018.36a4.139,4.139,0,0,0,.525.489c.152-.162.374-.311.439-.49.077-.214.017-2.551.02-2.779.007-.548,0-4.234.031-4.781.026-.436.373-.641.991-.635.579.006.917.212.933.629.027.715.011,4.568.017,5.283,0,.136-.032,2.391.049,2.5a.723.723,0,0,0,.44.262.575.575,0,0,0,.39-.234c.086-.129.092-2.39.1-2.539.031-.638,0-4.419.1-5.051a.986.986,0,0,1,.62-.6,1.066,1.066,0,0,1,.767.351c.388.682.788,4.516.974,5.236a4.625,4.625,0,0,1,.076,2.94,4.96,4.96,0,0,1-1.7,2.3,2.347,2.347,0,0,1-.71.368c-.891.261-.945.3-.931,1.02.024,1.263.041,1.887.079,3.149.156,5.111.32,7.956.48,13.066a3.233,3.233,0,0,0,.007.365c.057.391-.154.552-.716.531-.711-.028-1.426,0-2.14-.006-.783-.005-.863-.056-.844-.64.077-2.3.177-4.593.247-6.89.029-.943,0-1.886,0-2.829Z",
    transform: "translate(-413.505 -173.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M504.758,188.588q0,6.867,0,13.734c0,.711-.044.741-1.037.742-.5,0-1.01-.022-1.509.012-.577.039-.743-.152-.723-.529.061-1.109.1-2.219.162-3.329.163-3.145.337-6.29.488-9.436.036-.747,0-.77-1.024-.757-1.289.017-1.893.055-1.784-1.408.155-2.079.254-4.163.5-6.237a14.474,14.474,0,0,1,2.489-6.909,2.721,2.721,0,0,1,.706-.686.814.814,0,0,1,1.21.194,2.1,2.1,0,0,1,.289.965c.047,2.509.069,5.019.084,7.529.012,2.038,0,4.076,0,6.114Z",
    transform: "translate(-488.514 -173.553)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecipe);
export default __webpack_public_path__ + "static/media/icon-recipe.333a5502035ee967055b58fa7fc4ac66.svg";
export { ForwardRef as ReactComponent };